import React from 'react';
import './pullQuote.scss';
import quoteIcon from '../../Assets/quoteIcon.svg';

const PullQuoteWImg = ({ quote, author, descrip, photo }) => {
  return (
    <div className="pullQuoteWImg">
      <div className="pullQuoteImg__graphicCont">
        <img src={quoteIcon} alt="quote graphic" />
      </div>
      <div className="pullQuoteWImg__contentCont">
        <img src={photo} alt="man" />
        <div className="textCont">
          <p>{quote}</p>
          <p>
            <span className="authorBold"> {author}</span> {descrip}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PullQuoteWImg;
